export default function LevelArrow() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className="level-arrow"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 16L19 13.1132V18.8868L24 16ZM8 16.5H19.5V15.5H8V16.5Z"
        fill="#2F302F"
        fillOpacity="0.2"
      />
    </svg>
  );
}
